export const OnlineFriendList = ({ onlineFriends }) => {
    return (
        <div className="item">
            <span>
                Online Friends
            </span>

            {onlineFriends.length === 0 ? (
                <div className="offline">
                    No friends are online
                </div>
            ) : (
                onlineFriends.map((friend) => (
                    <div className="user" key={friend.id}>
                        <div className="userInfo">
                            <img
                                src={
                                    friend.profilePic?.startsWith("http") 
                                    ? friend.profilePic 
                                    : "/upload/" + friend.profilePic
                                }
                                alt={friend.name}
                            />
                            
                            <div className="online" />

                            <span>
                                {friend.name}
                            </span>     
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};